import { render } from "./WhatOurCustomerSaysTwo.vue?vue&type=template&id=c1c60d4c&scoped=true"
import script from "./WhatOurCustomerSaysTwo.vue?vue&type=script&lang=js"
export * from "./WhatOurCustomerSaysTwo.vue?vue&type=script&lang=js"

import "./WhatOurCustomerSaysTwo.vue?vue&type=style&index=0&id=c1c60d4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c60d4c"]])

export default __exports__